import {createSlice} from "@reduxjs/toolkit";

const initialPitsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  pitForEdit: undefined,
  lastError: null,
  locations: null,
  locationsTotalCount: 0
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const pitsSlice = createSlice({
  name: "pits",
  initialState: initialPitsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getPitById
    pitFetched: (state, action) => {
      state.actionsLoading = false;
      state.pitForEdit = action.payload.pitForEdit;
      state.error = null;
    },
    // findPits
    pitsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    //findLocations
    locationsFetched: (state, action) => {
      const { locationsTotalCount, locations } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.locations = locations;
      state.locationsTotalCount = locationsTotalCount;
    },
    // createPit
    pitCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.pitForEdit = action.payload.pit;
      state.entities.push(action.payload.pit);
    },
    // updatePit
    pitUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.pit.id) {
          return action.payload.pit;
        }
        return entity;
      });
    },
    // deletePit
    pitDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletePits
    pitsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // pitsUpdateState
    pitsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
